export const ADD_ALERT_MESSAGE = 'ADD_ALERT_MESSAGE'
export const DISMISS_ALERTS = 'DISMISS_ALERTS'
export const SET_ALERT_VIEWED = 'SET_ALERT_VIEWED'

export default {
  ADD_ALERT_MESSAGE,
  DISMISS_ALERTS,
  SET_ALERT_VIEWED
}



// WEBPACK FOOTER //
// ./src/store/modules/alert/mutation-types.js